<template>
  <div class="firstPage">
    <LensHome></LensHome>
  </div>
</template>

<script>
import LensHome from '../components/LensHome.vue'

export default {
  name: 'App',
  components: {
    LensHome
  }
}
</script>

<style>

</style>